export default __webpack_public_path__ + "static/media/annex-icon.164eaeba.svg";